import React, { Fragment } from 'react';

import PropTypes from 'prop-types';

import A from 'wanderu-component-react-router-link';
import { Button } from 'wanderu-components';
import { localize } from 'wanderu-i18n';
import { buildSearchUrlPath } from 'wanderu-utils';

import busIcon from 'wanderu-assets/images/bus.svg';
import flightIcon from 'wanderu-assets/images/flight.svg';
import trainIcon from 'wanderu-assets/images/train.svg';

import localesConfig from '../../../config/explorer.locales';
import TripContainer from '../../containers/Trip/Trip';
import events from '../events';

import styles from './Accordion.scss';

const TRANS_MODE_IMAGE = {
    bus: busIcon,
    flight: flightIcon,
    train: trainIcon,
};

function Accordion(props) {
    const {
        arriveAddr,
        arrivePlaceId,
        date,
        departAddr,
        departPlaceId,
        showDate = false,
        t,
        tripIds,
    } = props;

    const tagTypes = ['cheapest', 'fastest'];

    const searchUrlRequest = {
        arrivePlace: arriveAddr,
        arrivePlaceId,
        departDate: date,
        departPlace: departAddr,
        departPlaceId,
    };

    const searchUrl = buildSearchUrlPath(searchUrlRequest);

    return (
        <div className={styles.container}>
            <div className={styles.tripsContainer}>
                {['bus', 'train', 'flight'].map((mode) => {
                    if (!tripIds[mode]) {
                        return null;
                    }

                    return (
                        <Fragment key={mode}>
                            <div className={styles.mode}>
                                <img
                                    alt={t(mode)}
                                    className={styles.modeIcon}
                                    src={TRANS_MODE_IMAGE[mode]}
                                />
                                {t(`by-${mode}`)}
                            </div>
                            {tripIds[mode].map((id, i) => (
                                <TripContainer
                                    arriveAddr={arriveAddr}
                                    arrivePlaceId={arrivePlaceId}
                                    departAddr={departAddr}
                                    departPlaceId={departPlaceId}
                                    index={i}
                                    key={id}
                                    mode={mode}
                                    searchUrl={searchUrl}
                                    showDate={showDate}
                                    tag={tripIds[mode].length > 1
                                        ? tagTypes[i]
                                        : 'both'}
                                    totalTrips={tripIds[mode].length}
                                    tripId={id}
                                />
                            ))}
                        </Fragment>
                    );
                })}
                <div className={styles.buttonContainer}>
                    <A
                        className={styles.link}
                        href={searchUrl}
                        onClick={events.clickSeeAll}
                        rel="nofollow"
                        target="_blank"
                    >
                        <Button>
                            {t('see-all-trips')}
                        </Button>
                    </A>
                </div>
            </div>
        </div>
    );
}

Accordion.propTypes = {
    arriveAddr: PropTypes.string.isRequired,
    arrivePlaceId: PropTypes.string.isRequired,
    date: PropTypes.oneOfType([PropTypes.object, PropTypes.string]).isRequired,
    departAddr: PropTypes.string.isRequired,
    departPlaceId: PropTypes.string.isRequired,
    showDate: PropTypes.bool,
    t: PropTypes.func,
    tripIds: PropTypes.object.isRequired,
};

export { Accordion };
export default localize(Accordion, localesConfig.namespace);
